import BaseApi, { API_BASE_URL, ApiResponse } from './base';
import { Category } from './categories';

export interface Department {
  id: string;
  name: string;
  categories?: Category[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateDepartmentRequest {
  name: string;
  categoryIds?: string[];
}

export interface UpdateDepartmentRequest {
  name?: string;
  categoryIds?: string[];
}

class DepartmentsApi extends BaseApi {
  constructor(baseURL: string = API_BASE_URL) {
    super(baseURL);
  }

  async getDepartments(): Promise<ApiResponse<Department[]>> {
    return this.get<Department[]>(`/departments`);
  }

  async getDepartment(id: string): Promise<ApiResponse<Department>> {
    return this.get<Department>(`/departments/${id}`);
  }

  async createDepartment(data: CreateDepartmentRequest): Promise<ApiResponse<Department>> {
    return this.post<Department>('/departments', data);
  }

  async updateDepartment(id: string, data: UpdateDepartmentRequest): Promise<ApiResponse<Department>> {
    return this.patch<Department>(`/departments/${id}`, data);
  }

  async deleteDepartment(id: string): Promise<ApiResponse<{}>> {
    return this.delete<{}>(`/departments/${id}`);
  }
}

export default new DepartmentsApi();

